import { useSelector } from 'react-redux';

export const useBalanceRemainingForCreditCard = () => {
  const cart = useSelector((state) => state.cart.data);
  const { total } = cart;
  const totalCard = cart.tenders.reduce((tc, tender) => {
    if (
      tender.chargeStatus === 'Success' &&
      tender.tenderType === 'Credit Card'
    ) {
      return tc + tender.amountTendered;
    }
    return tc;
  }, 0);

  const amountByGiftCard = getAmountTenderedByGiftCard(cart);
  const amountByLoyaltyPoints = getAmountTenderedByLoyaltyPoints(cart);

  const balance = total - totalCard - amountByGiftCard - amountByLoyaltyPoints;

  return balance;
};

export const getAmountTenderedByGiftCard = (cart) => {
  const amount = cart.tenders.reduce((total, tender) => {
    if (tender.chargeStatus !== 'Faled' && tender.tenderType === 'Gift Card') {
      return total + tender.amountTendered;
    }
    return total;
  }, 0);
  return amount;
};

export const getAmountTenderedByLoyaltyPoints = (cart) => {
  let amount = 0;
  const loyaltyTender = cart.tenders.find(
    (tender) => tender.tenderType === 'Loyalty Points'
  );
  if (loyaltyTender) {
    amount = loyaltyTender.amountTendered;
  }
  return amount;
};
